import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Form,
  Grid,
  DatePicker,
  Typography,
  Flex,
  Radio,
  Select,
  Checkbox,
  Button,
  message,
  Drawer,
  Tooltip,
} from "antd";
import { useForm } from "antd/es/form/Form";
import InputField from "../../../../../components/Input/Input";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import { QuestionCircleOutlined } from "@ant-design/icons";

import {
  fetchServiceExpenseNumber,
  fetchSalesReturnAccounts,
  fetchServiceExpenseAccs,
  fetchServiceExpenseRecord,
} from "../serviceExpenseThunk";
import {
  setSupplier,
  setFormField,
  setEntryDate,
  setDueDate,
  setTaxMode,
  addOrderRow,
  calculateTotals,
  setTaxAcc,
  setDiscountAcc,
  setServiceExpenseAcc,
  setTagFeildNameid,
  setConversion,
  setConversionRate,
} from "../serviceExpenseSlice";
import SearchListAutoComplete from "../../../../../components/SearchListAutoComplete";
import {
  fetchItems,
  fetchSuppliers,
  fetchTaxAccs,
  fetchDiscountAccs,
  fetchTagGroupFields,

} from "../../../../../store/commonThunks/lookups";
import {
  selectDiscountAccs,
  selectSuppliers,
  selectTaxAccs,
} from "../../../../../store/commonSelectors/lookupsSelectors";
import StaticAutoComplete from "../../../../../components/StaticAutoComplete";
import { getCurrencyCodeWithName } from "../../../../../lib/currency";
import { convertCurrency } from "../../../../../utils";
import SupplierDrawer from "../../../../Purchase/Purchase/Supplier Entry/components/SupplierDrawer";
import { dateTimeFormat, formatToCompanyTimezone, getYearFromCompanyDate } from "../../../../../lib/functions";
import AddNewModal from "../../../../../components/DropDown/AddNewModal";
import TagCreateForm from "../../../../Settings/Tags/components/TagCreateForm";
import useMigrationDate from "../../../../../hooks/useMigrationDate";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreateServiceExpenseForm = ({ editId, authInfo }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = useForm();
  const screens = useBreakpoint();
  const location = useLocation();

  const {
    entryDate,
    dueDate,
    supplierInfo,
    narration,
    voucherNumber,
    taxMode,
    itemCart,
    serviceExpenseAccs,
    selectedServiceExpenseAcc,
    selectedTaxAcc,
    conversionRate,
    tag_field_id
  } = useSelector((s) => s.serviceExpense);

  const suppliers = useSelector(selectSuppliers);
  const lookups = useSelector((s) => s.lookups);
  const [isConvertCurrencyShow, SetIsConvertCurrencyShow] = useState(false);
  const [supplierDrawerOpen, setSupplierDrawerOpen] = useState(false);
  const [tagModal, setTagModal] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);

  const currency = authInfo?.currency || "AED";

  let tags =
    lookups.tagFields.map((tag) => ({
      label: tag.display_text,
      value: tag.id,
      tagid: tag.id,
    })) || [];

  const isFieldHidden = (fieldKey, pageKey = "service_expense_entry") => {
    return authInfo?.visibilitytabs?.some(
      (item) => item.page_key === pageKey && item.field_key === fieldKey
    );
  };

  useEffect(() => {
    if (editId) return;
    let formatedDate = entryDate ? dayjs(entryDate).toISOString() : null;
    let companydate = formatToCompanyTimezone(formatedDate);
    const year = getYearFromCompanyDate(companydate);
    dispatch(fetchServiceExpenseNumber(year));
  }, [entryDate]);

  useEffect(() => {

    dispatch(fetchServiceExpenseAccs());
    dispatch(fetchSuppliers());
    dispatch(fetchTagGroupFields(""));
    dispatch(fetchItems(""));
    dispatch(fetchTaxAccs()).then((res) => {
      if (res.payload && res.payload.length > 0) {
        dispatch(setTaxAcc(res.payload[0]));
      }
    });
    dispatch(fetchDiscountAccs()).then((res) => {
      if (res.payload && res.payload.length > 0) {
        dispatch(setDiscountAcc(res.payload[0]));
      }
    });
  }, [dispatch]);

  useEffect(() => {
    if (!editId) return;
    console.log(location, "location");

    dispatch(fetchServiceExpenseRecord({ location }));
  }, [location, dispatch]);

  useEffect(() => {
    if (serviceExpenseAccs.length === 1) {
      dispatch(setServiceExpenseAcc(serviceExpenseAccs[0]));
      dispatch(
        setFormField({
          field: "selectedServiceExpenseAcc",
          value: serviceExpenseAccs[0],
        })
      );
    }
  }, [serviceExpenseAccs, dispatch]);


  //   useEffect(() => {
  //   dispatch(fetchServiceExpenseRecord({ location }));
  // }, [location, dispatch]);

  const handleFieldChange = (field, value) => {
    dispatch(setFormField({ field, value }));
  };

  const handleSupplierSelect = (sup) => {
    if (!sup) {
      dispatch(setSupplier(null));
      return;
    }
    if (sup === "add_new") {
      setSupplierDrawerOpen(true);
      return;
    }

    // ✅ set supplier
    dispatch(setSupplier(sup));

    // ✅ add first blank row if table is empty
    if (itemCart.length == 0 && sup) {
      const newRow = {
        key: Date.now(),
        item_id: null,
        product: "",
        quantity: 1,
        rate: 0,
        tax_per: 0,
        discount: 0,
        discountAmt: null,
        discountMode: "percent",
        bonus: false,
      };
      dispatch(addOrderRow(newRow));
    }
  };

  const handletaggroup = (e, selectedOption) => {
    const value = selectedOption?.map((tag) => tag.tagid);


    dispatch(setTagFeildNameid(value));
  };

  const {disabledDate} = useMigrationDate();

  return (
    <div>
      <Flex justify="space-between" align="center">
        <Title level={3}>
          Service Expense
        </Title>

        <Tooltip title="Help">
          <Button
            type="text"
            icon={<QuestionCircleOutlined style={{ fontSize: 18 }} />}
            onClick={() => setHelpOpen(true)}
          />
        </Tooltip>
      </Flex>
      <Form
        form={form}
        layout={!screens.md ? "vertical" : "horizontal"}
        style={{ width: "100%", maxWidth: "1200px" }}
        colon={false}
        labelCol={!screens.md ? undefined : { span: 8 }}
        wrapperCol={!screens.md ? undefined : { span: 18 }}
      >
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item
              label="Search Supplier"
              rules={[{ required: true, message: "Select Supplier" }]}
            >
              <SearchListAutoComplete
                entityType="supplier"
                placeholder="Supplier"
                optionsList={(suppliers || []).map((s) => ({
                  sale_id: s.acc_id,
                  display_text: s.acc_name || s.institution_name,
                  raw: s,
                }))}
                value={
                  supplierInfo?.acc_id
                    ? {
                      value: supplierInfo.acc_name,
                      label: supplierInfo.acc_name,
                      display_text: supplierInfo.acc_name,
                      raw: supplierInfo,
                    }
                    : null
                }
                onSelect={(obj) => handleSupplierSelect(obj?.raw ? obj?.raw : obj)}
                showAddNew={true}
              />
            </Form.Item>

            <Form.Item label="Institution Name">
              <InputField
                value={supplierInfo?.institution_name || ""}
                disabled
              />
            </Form.Item>
            <Form.Item label="Supplier Address">
              <InputField value={supplierInfo?.address || ""} disabled />
            </Form.Item>
            <Form.Item label="Contact No">
              <InputField value={supplierInfo?.contact_no || ""} disabled />
            </Form.Item>
              <Form.Item label="Discount">
                <Radio.Group
                  options={[
                    { label: "On Total", value: "on_total" },
                    { label: "On Individual Item", value: "on_item" },
                  ]}
                  onChange={(e) => {
                    dispatch(setTaxMode(e.target.value));
                    dispatch(calculateTotals({ authInfo }));
                  }}
                  value={taxMode}
                />
              </Form.Item>


            {isConvertCurrencyShow && (
              <Form.Item label="Choose Currency">
                <Select
                  showSearch
                  placeholder="Select Currency"
                  style={{ width: "100%", minWidth: 200 }}
                  options={getCurrencyCodeWithName().map((c) => ({
                    value: c.code,
                    label: `${c.currency} (${c.code})`,
                  }))}
                  onChange={async (toCurrency) => {
                    const rate = await convertCurrency(currency, toCurrency);

                    if (rate) {
                      dispatch(
                        setConversion(toCurrency, "conversion_currency")
                      );
                      dispatch(setConversionRate(rate));
                    }
                  }}
                />
              </Form.Item>
            )}
          </Flex>

          <Flex
            vertical
            gap={10}
            style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}
          >
            <Form.Item label="Voucher No.">
              <InputField
                value={voucherNumber}
                disabled
                data-testid="service-exp-no"
              />
            </Form.Item>

            <Form.Item
              label="Entry Date"
              rules={[{ required: true, message: "Entry Date Is Required" }]}
            >
              <DatePicker
                value={entryDate ? dayjs(entryDate) : null}
                onChange={(d) => dispatch(setEntryDate(d ? d.toISOString() : null))}
                style={{ width: "100%" }}
                format={dateTimeFormat}
                                      disabledDate={disabledDate}
              />
            </Form.Item>

            <Form.Item
              label="Service Expense Account"
              rules={[{ required: true }]}
            >
              <StaticAutoComplete
                optionsList={serviceExpenseAccs}
                value={
                  selectedServiceExpenseAcc
                    ? {
                      value: selectedServiceExpenseAcc.acc_id,
                      label: selectedServiceExpenseAcc.acc_name,
                      display_text: selectedServiceExpenseAcc.acc_name,
                      raw: selectedServiceExpenseAcc,
                    }
                    : null
                }
                onSelect={(acc) => {
                  dispatch(
                    setFormField({
                      field: "selectedServiceExpenseAcc",
                      value: acc,
                    })
                  );
                  dispatch(setServiceExpenseAcc(acc));
                }}
                placeholder="Select a service expense account"
                disabled={!serviceExpenseAccs?.length}
              />
            </Form.Item>

            <Form.Item label="Search Tags">
              <Select
                data-testid="roles-select"
                className="tag-multiselect"
                maxTagCount="responsive"
                mode="multiple"
                style={{ width: "100%" }}
                onChange={(e, options) => handletaggroup(e, options)}
                value={tag_field_id || null}
                placeholder="Select Tags"
                options={tags}
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: 8,
                        borderTop: "1px solid #f0f0f0",
                      }}
                    >
                      <Button type="link" onClick={() => setTagModal(true)}>
                        + Add New Tag
                      </Button>
                    </div>
                  </>
                )}
              />
            </Form.Item>
            {!isFieldHidden("Convert Currency") && (
              <Form.Item>
                <Checkbox
                  onChange={(e) => {
                    SetIsConvertCurrencyShow(e.target.checked ? true : false);
                  }}
                >
                  Convert Currency
                </Checkbox>
              </Form.Item>
            )}

            {isConvertCurrencyShow && (
              <Form.Item label="Conversion Rate">
                <InputField value={conversionRate} disabled />
              </Form.Item>
            )}
          </Flex>
        </Flex>
      </Form>

      <SupplierDrawer
        open={supplierDrawerOpen}
        onClose={() => setSupplierDrawerOpen(false)}
        authInfo={authInfo}
        onCreated={(supplier) => {
          if (!supplier) return;

          // 1️⃣ close drawer first
          setSupplierDrawerOpen(false);

          //  Update Redux
          dispatch(setSupplier(supplier));
          // dispatch(fetchPurchaseEntryNumber());
          dispatch(fetchSuppliers());
          if (serviceExpenseAccs.length === 1) dispatch(setServiceExpenseAcc(serviceExpenseAccs[0]));

          //  Update form field
          // form.setFieldValue("search_supplier", {
          //   value: supplier.acc_name,
          //   label: supplier.acc_name,
          //   display_text: supplier.acc_name,
          //   raw: supplier,
          // });

          // if no rows → add first empty row
          if (itemCart.length === 0) {
            dispatch(
              addOrderRow({
                key: Date.now(),
                item_id: null,
                product: "",
                quantity: 1,
                rate: 0,
                tax_per: 0,
                discount: 0,
                discountAmt: null,
                discountMode: "percent",
                bonus: false,
              })
            );
          }
          //  Load dependent data (same as normal select)
          dispatch(fetchItems(supplier?.party_type || false));
          dispatch(fetchTaxAccs()).then((res) => {
            if (res.payload?.length) {
              dispatch(setTaxAcc(res.payload[0]));
            }
          });

          dispatch(fetchDiscountAccs()).then((res) => {
            if (res.payload?.length) {
              dispatch(setDiscountAcc(res.payload[0]));
            }
          });
        }}
      />

      <AddNewModal
        open={tagModal}
        title="Add Tag"
        onClose={() => setTagModal(false)}
      >
        <TagCreateForm
          authInfo={authInfo}
          onSuccess={async ({ groupId, createdName }) => {
            const res = await dispatch(fetchTagGroupFields("")).unwrap();

            const match = res.find(
              (t) =>
                t?.raw?.field_name?.toLowerCase() ===
                createdName.toLowerCase()
            );

            if (!match) {
              message.warning("Tag creation failed or tag not found");
              setTagModal(false);
              return;
            }

            if (tag_field_id.includes(match.id)) {
              message.info("Tag already exists and is already selected");
              setTagModal(false);
              return;
            }

            // ✅ New tag OR existing but not selected
            dispatch(setTagFeildNameid([...tag_field_id, match.id]));
            message.success("Tag added");

            setTagModal(false);
          }}
        />

      </AddNewModal>
      <Drawer
        title="Service Expense Help"
        open={helpOpen}
        onClose={() => setHelpOpen(false)}
        width={!screens.sm ? "100%" : 420}
        styles={{
          wrapper: {
            paddingTop: !screens.md ? "80px" : undefined
          }
        }}
      >
        <div style={{ lineHeight: 1.8 }}>
          <h2
            style={{
              fontSize: "18px",
              fontWeight: 600,
              marginBottom: "12px",
              marginLeft: "8px",
            }}
          >
            Service Expense Entry
          </h2>

          <p
            style={{
              color: "#555",
              marginBottom: "16px",
              marginLeft: "8px",
            }}
          >
            The Service Expense Entry module is used to record and manage
            service-related expenses within the ERP system. It helps track
            supplier expenses, service charges, taxes, and expense-related
            transactions efficiently.
          </p>

          <div
            style={{
              background: "#f5f5f5",
              padding: "14px",
              borderRadius: "8px",
              marginBottom: "16px",
            }}
          >
            <strong>Steps to Create Service Expense</strong>

            <ol style={{ paddingLeft: "20px", marginTop: "10px" }}>
              <li>Open <strong>Service → Service Expense</strong></li>
              <li>Select or create the supplier</li>
              <li>Verify voucher number and entry date</li>
              <li>Select the service expense account</li>
              <li>Add expense items with quantity and pricing</li>
              <li>Apply discounts if required</li>
              <li>Add tags or additional notes if needed</li>
              <li>Review totals and expense details</li>
              <li>Click <strong>Save</strong> to complete the entry</li>
            </ol>
          </div>

          <div
            style={{
              background: "#fafafa",
              border: "1px solid #eee",
              padding: "14px",
              borderRadius: "8px",
            }}
          >
            <strong>Important Notes</strong>

            <ul
              style={{
                paddingLeft: "18px",
                marginTop: "10px",
                color: "#666",
              }}
            >
              <li>Supplier and expense account selection are required.</li>
              <li>Expense totals change based on VAT and discount settings.</li>
              <li>Currency conversion can be enabled if required.</li>
              <li>Verify expense details carefully before saving.</li>
            </ul>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default CreateServiceExpenseForm;
